import styled from 'styled-components';
import result from '../data/result.json';
import ResultContent from '../components/ResultContent';
import TagList from '../components/TagList';
import images from '../img';

function Result({
    resultNum,
    setPage
}) {
    const currentResultKey = result.key[resultNum].name;
    const currentResult = result.data[currentResultKey];
    currentResult.name = currentResultKey;
    const resultContent = currentResult.content || [
        {
            picture: null,
            title: "title",
            description: "description"
        },
        {
            picture: null,
            title: "title",
            description: "description"
        },
        {
            picture: null,
            title: "title",
            description: "description"
        }
    ];
    const resultTag = [
        "안전",
        "건강",
        "친환경"
    ]
    return (<ResultStyleWrapper>
        <div className='result-head'>
            <div className='logo-wrap'>
                <img className='logo' src={images["life_logo-pc_1.png"]} />
                <img className='logo-mobile' src={images["life_logo-m_1.png"]} />
            </div>
            <button className='result-btn1-pc' onClick={() => {
                setPage("lifestyle");
            }}>
                <img src={images["btn_result-pc1.png"]} />
            </button>
            <div className='result-title-wrap'>
                <div className='result-title'>
                    {currentResult.name}
                </div>
                <div className='result-description'>
                    {currentResult.description}
                </div>
                <TagList resultTag={resultTag} />
            </div>
        </div>
        <div className='result-body'>
            {resultContent.map((x, i) =>
                <ResultContent key={i} pictureUrl={x.picture} title={x.title} description={x.description} />)}
        </div>
        <div className='result-foot'>
            <TagList resultTag={resultTag} />
            <button className='result-btn1-mobile'
                onClick={() => {
                    setPage("lifestyle");
                }}>
                <img src={images["btn_result-m1.png"]} />
            </button>
        </div>
    </ResultStyleWrapper>);
}

export default Result;

const ResultStyleWrapper = styled.div`
    .result-tag{
        display: flex;
        margin: 0;
        padding:0;
        list-style: none;
        justify-content: center;
        li{
            padding: 0.8rem 2rem 1rem;
            border-radius: 99rem;
            border: solid 1px #dbdbdb;
            background-color: #fff;
            margin:1rem;
            font-size: 2rem;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.85;
            letter-spacing: normal;
            text-align: center;
            color: #830001;
        }
    }
    .result-btn1-mobile{
        display: none;
    }
    .result-body{
        padding:0 13rem 4.5rem;
        display: flex;
        justify-content: space-between;
        .result-content{
            width: 50rem;
        }
    }
    .result-head{
        height: 35.0rem;
        padding: 8rem 10.3rem 6rem 13rem;
        background-color: #edeeef;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .result-tag{
            display: none;
        }
        .result-btn1-pc{
            position:absolute;
            top:9.2rem;
            right: 11.4rem;
            border:none;
            background-color:transparent;
            cursor: pointer;
            img{
                height:11.4rem;
            }
        }
        .logo-wrap{
            display: flex;
            width: 100%;
            .logo-mobile{
                display: none;
            }
            .logo{
                height: 2.6rem;
            }
        }
        .result-title-wrap{
            .result-title{
                font-size: 6rem;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.22;
                letter-spacing: -0.06rem;
                text-align: center;
                color: #000;
                margin-bottom:1.6rem;
            }
            .result-description{
                font-size: 2.6rem;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.42;
                letter-spacing: -0.065rem;
                text-align: center;
                color: #494949;
            }
        }
    }
    @media screen and (max-width:990px){
        .result-tag{
            flex-wrap: wrap;
            li{
                font-size: 1.4rem;
                padding:0.5rem 1rem;
                margin:0.5rem 0.4rem;
            }
        }
        .result-foot{
            padding-bottom:3.5rem;
            .result-tag{
                display: none;
            }
        }
        .result-btn1-mobile{
            display: block;
            height:4.5rem;
            padding:0;
            margin:0;
            border:0;
            background-color: transparent;
            margin:auto;
            cursor: pointer;
            img{
                height: 100%;
            }
        }
        .result-body{
            display: flex;
            flex-direction: column;
            padding:0;
            .result-content{
                width: 100%;
                box-sizing: border-box;
                padding:5.5rem 2rem 8.3rem;
                &:nth-of-type(2n){
                    background-color: #edeeef;
                    &::before{
                        border-color:#edeeef;
                    }
                }
                &:last-of-type{
                    padding-bottom:3.5rem;
                }
                .picture{
                    width: 100%;
                    height:17.7rem;
                    margin-bottom:2.7rem;
                }
                .title{
                    font-size: 2.4rem;
                    text-align: center;
                    margin-bottom:0.9rem;
                }
                .description{
                    font-size: 1.7rem;
                    text-align: center;
                }
            }
        }
        .result-head{
            padding:5.5rem 2.5rem;
            height:unset;
            .result-btn1-pc{
                display: none;
            }
            .logo-wrap{
                .logo{
                    display: none;
                }
                .logo-mobile{
                    margin:auto;
                    height:11rem;
                    display: block;
                    margin-bottom:1.7rem;
                }
            }
            .result-title-wrap{
                .result-title{
                    font-size:3.6rem;
                }
                .result-description{
                    font-size:1.6rem;
                    margin-bottom:2.62rem;
                }
            }
        }
    }
`;